import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
// import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// management
const AppManagementLogs = Loadable(lazy(() => import('pages/management/logs-data/index')));
const AppManagementUsers = Loadable(lazy(() => import('pages/management/users/index')));

const ManagementRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'management',
          children: [
            {
              path: 'logs',
              element: <AppManagementLogs />
            },
            {
              path: 'users',
              element: <AppManagementUsers />
            }
          ]
        }
      ]
    }
  ]
};

export default ManagementRoutes;
